// extracted by mini-css-extract-plugin
module.exports = {"alertLabel":"product-variant-select_alertLabel__nvkQN","disabledLabel":"product-variant-select_disabledLabel__0rcqY","itemContent":"product-variant-select_itemContent__Dky6d"};